import React from 'react';

import OldPageSectionHeading from 'components/structure/OldPageSectionHeading';
import websitePage from 'hoc/websitePage/websitePage';

import SectionFAQ from './patterns/SectionFAQ/SectionFAQ';

function SCR() {
  return (
    <>
      <OldPageSectionHeading
        intlKey="SCR.TITLE"
        textAlign="center"
      />
      <SectionFAQ />
    </>
  );
}

export default websitePage({
  routeKey: 'SCR',
})(SCR);
